import { use_slice_ui } from '@/hooks/store/use_slices';
import { G_IMAGE__master_component } from '../../nodes/node/fields/image/_views/G_IMAGE__master_component';
import { G_LAYOUT__image_edit_base } from '../_base/G_LAYOUT__image_edit_base';

export function G_LAYOUT__image_view() {
  /*
   * STORE
   */

  const { g_image_edit__field } = use_slice_ui(['g_image_edit__field']);

  /*
   * HTML
   */

  return (
    <G_LAYOUT__image_edit_base>
      <G_IMAGE__master_component field={g_image_edit__field} />
    </G_LAYOUT__image_edit_base>
  );
}
